module.exports = __webpack_public_path__ + "img/cerrar_dropdown.10397b83.svg";